exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.international .el-dropdown-link {\n  cursor: pointer;\n  color: #c0ccda;\n  font-size: 14px;\n}\n.el-icon-arrow-down {\n  font-size: 14px;\n}", ""]);

// exports
